import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import SidebarComp from './layout/sidebar';
import Spinner from '../components/ui/spinner';
import { selector as spinnerSelector } from '../components/ui/spinner/spinnerSlice';
import { Notification } from '../components/notification/';

const AppWrapper: React.FC<IProps> = ({ children }) => {

  const isActive: boolean = useSelector(spinnerSelector).isActive;

  return (
    <div className="AppWraper">
      <Spinner isActive={isActive} />
      <Notification />
      <div className='main-wrapper'>
        <div className='sidebar_container'>
          <SidebarComp />
        </div>
        <main className='main_container'>
          {children} 
        </main>
      </div>

    </div>
  );
}


export interface IProps {children: React.ReactNode }

export default connect()(AppWrapper);

